interface StructuredDataProps {
  data: Record<string, unknown>;
}

export default function JsonLd({ data }: StructuredDataProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data, null, 2) }}
    />
  );
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爱漫画网',
    url: 'https://aimanhua.com',
    description: '爱漫画网提供下拉式漫画阅读、翻页漫画、无弹窗漫画等多种阅读模式，支持漫画全屏观看。沉浸式追漫体验让免费看漫画全集更流畅。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@aimanhua.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
    sameAs: [
      'https://aimanhua.com',
    ],
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '爱漫画网',
    url: 'https://aimanhua.com',
    description: '爱漫画网提供下拉式漫画阅读、翻页漫画、无弹窗漫画等多种阅读模式，支持漫画全屏观看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://aimanhua.com/category/all?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getWebPageSchema(name: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: '爱漫画网',
      url: 'https://aimanhua.com',
    },
  };
}

export function getBreadcrumbSchema(items: Array<{ name: string; url: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function getArticleSchema(article: {
  title: string;
  description: string;
  image: string;
  datePublished: string;
  dateModified: string;
  author: string;
  url: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    image: article.image,
    datePublished: article.datePublished,
    dateModified: article.dateModified,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    publisher: {
      '@type': 'Organization',
      name: '爱漫画网',
      url: 'https://aimanhua.com',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': article.url,
    },
  };
}

export function getFAQSchema(faqs: Array<{ question: string; answer: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}